import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { PAINTING_SHAPE } from "../../../../../constants/paintingConstants";
import Item from "../item";

class List extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    const { items, onAppointment, onFavorite } = this.props;

    return (
      <div className="b-paintings__row row">
        {(items || []).map((item) =>
          <Item
            item={item}
            key={item.id}
            isLarge={false}
            onAppointment={onAppointment}
            onFavorite={onFavorite}
          />
        )}
      </div>
    )
  }
}

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(PAINTING_SHAPE)),
  onAppointment: PropTypes.func.isRequired,
  onFavorite: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(List)